<template>
  <div class="pt-editor-help">
    <div v-if="publicTransportHelpShow" class="pt-editor-help__container">
      <div class="pt-editor-help__subcontainer" v-if="state.mode === 'create'">
        <div class="pt-editor-help__subtitle">
          Создание
        </div>
        <pt-sp-create v-if="mode === 'stop_points'" :theme="theme" />
        <pt-route-create v-else :theme="theme" />
      </div>
      <div class="pt-editor-help__subcontainer" v-else>
        <div class="pt-editor-help__subtitle">
          Редактирование
        </div>
        <pt-sp-edit v-if="mode === 'stop_points'" :theme="theme" />
        <pt-route-edit v-else :theme="theme" />
      </div>
    </div>
    <div
      @click="publicTransportHelpShow = !publicTransportHelpShow"
      class="pt-editor-help__title"
    >
      <i
        :class="
          publicTransportHelpShow ? 'el-icon-caret-top' : 'el-icon-caret-right'
        "
      />
      Помощь
    </div>
  </div>
</template>

<script>
import PtSpCreate from "./help/pt-sp-create";
import PtRouteCreate from "./help/pt-route-create";
import PtSpEdit from "./help/pt-sp-edit";
import PtRouteEdit from "./help/pt-route-edit";

export default {
  props: ["mode", "state"],
  components: {
    PtSpCreate,
    PtRouteCreate,
    PtSpEdit,
    PtRouteEdit
  },
  data() {
    return {
      publicTransportHelpShow: true
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    }
  },
  methods: {
    getSrc() {
      return `../../assets/images/public-transport/stop_points_edit_dark.gif`;
    }
  }
};
</script>

<style lang="scss">
.pt-editor-help {
  color: var(--text_secondary) !important;

  &__title {
    font-size: 12px;
    cursor: pointer;
    margin: 16px;
    margin-top: 5px;
  }

  &__container {
    padding: 16px;
    border-top: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;
  }

  &__subtitle {
    font-size: 11px;
    font-weight: bold;
    margin-bottom: 12px;
    border-radius: var(--border-radius);
    text-transform: uppercase;
    color: var(--text_primary) !important;
  }

  &__block {
    font-size: 11px;

    b {
      color: var(--text_primary) !important;
    }

    &:not(:first-child) {
      margin-top: 5px;
    }
  }

  &__image {
    margin-top: 16px;
    width: 100%;
    height: auto;
    border-radius: 4px;
    color: var(--text_secondary) !important;
    background-color: var(--bg_containers) !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
